import React, { useEffect } from "react";

const FirstAd = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error("AdSense error:", err);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", margin: " auto" }}
      data-ad-client="ca-pub-8708658960573638"
      data-ad-slot="5757722810"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default FirstAd;